import { DocumentTypeEnum } from 'api-hooks/order/travel-document';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function DetailTable(props: {
  detail: any;
  documentType: string;
}) {
  const { t } = useTranslation();
  const { documentType } = props;

  const columns = [
    ...(documentType !== DocumentTypeEnum.visa
      ? [
          {
            header: t('common:type'),
            accessorKey: 'type',
            minSize: 100,
            dataType: ColumnDataType.text,
            required: true,
          },
        ]
      : [
          {
            header: t('document:document_type'),
            accessorKey: 'label',
            minSize: 250,
            dataType: ColumnDataType.text,
            required: true,
          },
          {
            header: t('document:biometric'),
            accessorKey: 'biometric',
            minSize: 100,
            dataType: ColumnDataType.checkbox,
          },
          {
            header: t('document:appointment_date'),
            accessorKey: 'appointmentAt',
            minSize: 100,
            dataType: ColumnDataType.date,
            required: true,
          },
          {
            header: t('document:appointment_time'),
            accessorKey: 'appointmentAt',
            minSize: 20,
            dataType: ColumnDataType.time,
            required: true,
          },
        ]),
    ...(documentType === DocumentTypeEnum.insurance
      ? [
          {
            header: t('common:started_at'),
            accessorKey: 'startAt',
            minSize: 100,
            dataType: ColumnDataType.date,
            required: true,
          },
          {
            header: t('common:ended_at'),
            accessorKey: 'endAt',
            minSize: 100,
            dataType: ColumnDataType.date,
            required: true,
          },
          {
            header: t('common:days'),
            accessorKey: 'days',
            minSize: 20,
            dataType: ColumnDataType.number,
            minNumber: 0,
            disabled: true,
          },
          {
            header: t('common:package'),
            accessorKey: 'package',
            minSize: 100,
            dataType: ColumnDataType.text,
            required: true,
          },
          {
            header: t('common:company'),
            accessorKey: 'company',
            minSize: 100,
            dataType: ColumnDataType.text,
            required: true,
          },
          {
            header: t('common:cover_area'),
            accessorKey: 'coverArea',
            minSize: 100,
            dataType: ColumnDataType.text,
            required: true,
          },
        ]
      : []),
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 300,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      required: true,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={props.detail}
        dispatch={() => {}}
        disabled
      />
    </div>
  );
}
